import { mapState } from "vuex"

export default {
  mounted: function () {
    this.$sentry.configureScope(
      function (scope) {
        scope.setUser({
          email: this.USER_EMAIL,
          id: this.USER_ID,
        })
      }.bind(this)
    )
  },
  computed: {
    ...mapState({
      USER_EMAIL: (state) => state.user.email,
      USER_ID: (state) => state.user.id,
    }),
  },
}
